import axios, {AxiosError, AxiosResponse} from 'axios'
import formDataAxios from './formDataAxios'
import {clearSessionAndRedirectToLogin} from './AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL
const sessionId = localStorage.getItem('sessionId')
const token = localStorage.getItem('token')

const dataAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Headers': '*',
    'X-Session-ID': sessionId ? sessionId : '',
  },
})

// Add request interceptor to log requests
dataAxios.interceptors.request.use(
  (config) => {
    // console.log('Request:', { 
    //   method: config.method, 
    //   url: config.url,
    //   headers: config.headers,
    //   data: config.data
    // })
    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

dataAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    // console.log('Response:', { 
    //   status: response.status, 
    //   statusText: response.statusText,
    //   data: response.data
    // })
    return response
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      clearSessionAndRedirectToLogin()
    }

    return Promise.reject(error)
  }
)
export const setAuthToken = (token: string | null) => {
  if (token) {
    dataAxios.defaults.headers.common = {Authorization: `bearer ${token}`}
    formDataAxios.defaults.headers.common = {Authorization: `bearer ${token}`}

    localStorage.setItem('token', token)
  } else {
    delete dataAxios.defaults.headers.common['Authorization']
    delete formDataAxios.defaults.headers.common['Authorization']
    localStorage.removeItem('token')
  }
}

// Check if token exists in localStorage and set it
if (token) {
  dataAxios.defaults.headers.common = {Authorization: `bearer ${token}`}
  formDataAxios.defaults.headers.common = {Authorization: `bearer ${token}`}
}

export default dataAxios
